import { TreeCheckboxSelectionKeys } from 'primereact/tree';

import { TreeNode } from '../types/interfaces';

export function findNodeByKey(
  obj: TreeNode[],
  searchKey: string
): TreeNode | null {
  for (let i = 0; i < obj.length; i++) {
    if (obj[i].key === searchKey) {
      return obj[i];
    }

    if (obj[i].children) {
      const childResult = findNodeByKey(obj[i].children!, searchKey);
      if (childResult) {
        return childResult;
      }
    }
  }

  return null;
}

export const hasChildren = (node: TreeNode, treeNodes: TreeNode[]) => {
  for (const treeNode of treeNodes) {
    if (treeNode.key === node.key) {
      return treeNode.children && treeNode.children.length > 0;
    }
    if (treeNode.children) {
      if (hasChildren(node, treeNode.children)) {
        return true;
      }
    }
  }
  return false;
};

export function findNodesByKey(
  obj: TreeNode[],
  searchKeys: string[]
): TreeNode[] {
  let results: TreeNode[] = [];

  for (let i = 0; i < obj.length; i++) {
    if (searchKeys.includes(obj[i].key)) {
      results.push(obj[i]);
    }

    if (obj[i].children) {
      const childResults = findNodesByKey(obj[i].children!, searchKeys);
      results = [...results, ...childResults];
    }
  }

  return results;
}

export const findNodeWithParent = (
  nodes: TreeNode[],
  key: string
): { node: TreeNode | null; parent: TreeNode | null } => {
  for (const node of nodes) {
    if (node.key === key) {
      return { node, parent: null }; // Node is found at root level
    }
    if (node.children) {
      const result = findNodeWithParent(node.children, key);
      if (result.node) {
        return { node: result.node, parent: node }; // Node found in children
      }
    }
  }
  return { node: null, parent: null }; // Node not found
};

export function getParentKey(obj: TreeNode): string {
  return obj.key.split('-').slice(0, -1).join('-');
}

export function removeEmployeeChildren(nodes: TreeNode[]): (TreeNode | null)[] {
  return nodes.map((node) => {
    if (!node.children || node.children.length === 0) {
      return node.data === 'Сотрудник' ? null : node;
    }

    const filteredChildren = removeEmployeeChildren(
      node.children as TreeNode[]
    );
    const nonNullChildren = filteredChildren.filter(
      (child) => child !== null
    ) as TreeNode[];

    if (nonNullChildren.length === 0 && node.data === 'Сотрудник') {
      return null;
    }

    return {
      ...node,
      children: nonNullChildren
    };
  });
}

export function getAllKeys(nodes: TreeNode[]): string[] {
  let keys: string[] = [];

  nodes.forEach((node) => {
    keys.push(node.key);

    if (node.children && node.children.length > 0) {
      const childKeys = getAllKeys(node.children);
      keys = [...keys, ...childKeys];
    }
  });

  return keys;
}

export const extractSelectedNodes = (
  nodes: TreeNode[],
  selectedKeys: TreeCheckboxSelectionKeys
) => {
  const result: TreeNode[] = [];

  const traverse = (node: TreeNode) => {
    if (selectedKeys && selectedKeys[node?.key]?.checked) {
      const treeNode: TreeNode = {
        key: node.key,
        label: node.label,
        isPerson: node.isPerson,
        userRole: node.userRole,
        children: node.children ? [] : undefined // Only add children if they exist
      };

      result.push(treeNode);
    }

    if (node.children) {
      node.children.forEach((child) => traverse(child));
    }
  };

  nodes.forEach((node) => traverse(node));
  return result;
};
